import {get as getWebsite} from './services/editor/website';
import Cookies from "js-cookie";
import dashboardModule from "./storeModules/dashboardModule";
import {
  getOfficeTokenFromCookie,
  isOfficeTokenUsable,
  refreshOfficeToken,
} from './services/officeToken';

const keyCookieOffice = 'officeToken';
export default {
  modules: {
    dashboard: dashboardModule
  },
  state: {
    languages: false,
    user: {},
    token: localStorage.getItem('token') || '',
    office_token: Cookies.get(keyCookieOffice) || '',
    website: false, // website current edit
    files_manager: {
      Files: {},
      Images: {},
      Videos: {}
    }
  },
  getters: {
    user(store) {
      return store.user;
    },

    getOfficeToken(store) {
      return store.office_token;
    },

    getLanguages(store) {
      return store.languages;
    },
    token(store) {
      return store.token;
    },
    filesManager(store) {
      return store.files_manager;
    },
    website: state => state.website
  },
  mutations: {
    user(state, user) {
      state.user = user;
    },

    office_token(state, token) {
      state.office_token = token;
    },

    filesManager(state, files_manager) {
      state.files_manager = files_manager;
    },

    website(state, website) {
      state.website = website;
    },

    languages(state, languages) {
      state.languages = languages;
    },
  },
  actions: {
    updateUser(store, user) {
      store.commit('user', user);
    },
    updatetoken(store, token) {
      store.commit('token', token);
    },
    updateOfficeToken(store, token) {
      if (!token || typeof token !== 'string' || !token.trim()) {
        return;
      }

      const normalized = token.trim();
      store.commit('office_token', normalized);

      Cookies.set(keyCookieOffice, normalized, { expires: 3 });
      const element = document.getElementsByTagName('builderall-appshell');
      if (element.length)
        element[0].setAttribute('token', normalized);

    },
    ensureOfficeToken({ state, dispatch, commit }) {
      let token = state.office_token || '';

      if (!token) {
        token = getOfficeTokenFromCookie();
        if (token) {
          commit('office_token', token);
        }
      }

      if (isOfficeTokenUsable(token)) {
        return Promise.resolve(token);
      }

      return refreshOfficeToken()
        .then((response) => {
          const nextToken = response && response.data && response.data.office_token
            ? response.data.office_token
            : '';

          if (!response.data || !response.data.success || !nextToken) {
            return Promise.reject(new Error(
              (response && response.data && response.data.message) || 'Unable to refresh office token'
            ));
          }

          return dispatch('updateOfficeToken', nextToken).then(() => nextToken);
        });
    },
    updateFilesManager(store, files) {
      store.commit('files', files);
    },
    clearWebsite(store) {
      store.commit('files', false);
    },
    updateWebsite({commit, state}, websiteIdEncrypted, force = false) {

      if (force || !(state.website)) {

        return new Promise((resolve, reject) => {
          getWebsite(websiteIdEncrypted)
            .then(response => {
              // console.log('response', response);
              commit('website', response.data);
              resolve(response.data);

              // console.log('force || !(state.website)', force || !(state.website), force, !state.website);
            })
            .catch(err => {
              console.log(err);
              reject(err);
            });
        });
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/js/store.js